export default class MapboxButtonsControl {
  constructor({
    className = '',
    title = '',
    iconName = '',
    clickHandler,
  }) {
    this.className = className;
    this.title = title;
    this.iconName = iconName;
    this.clickHandler = clickHandler;
  }

  onAdd(map) {
    this.map = map;
    this.btn = document.createElement('button');
    this.btn.className = `mapboxgl-ctrl-icon ${this.className}`;
    this.btn.type = 'button';
    this.btn.title = this.title;
    this.btn.onclick = this.clickHandler;

    this.icon = document.createElement('v-icon');
    this.icon.className = 'v-icon notranslate material-icons';
    this.icon.innerHTML = this.iconName;
    this.icon.style.fontSize = '16px';
    this.btn.appendChild(this.icon);

    const mapboxglCtrlGroup = document.createElement('div');
    mapboxglCtrlGroup.className = 'mapboxgl-ctrl-group mapboxgl-ctrl';
    mapboxglCtrlGroup.appendChild(this.btn);

    return mapboxglCtrlGroup;
  }
}
